import React from "react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
} from "chart.js";
import { Doughnut, Pie, Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useThemeContext } from "../../../../context";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  ChartDataLabels,
  LineElement,

  PointElement,
);
const DonoughtChart = ({
  dashboardTickets,
  itemListData,
  DonutChart,
  PieChart1,
  PieChartReport,
  lmsReportData,
  SwItemPieChart,
  LineChart,
  datahistoricalData,
  PieChartDashboard,
}) => {
  const { mode } = useThemeContext();
  const graphData = {
    labels: ["Open", "In Progress", "Closed"],
    datasets: [
      {
        label: "Tickets",
        data: [
          dashboardTickets?.openTickets,
          dashboardTickets?.inProgressTickets,
          dashboardTickets?.closedTickets,
        ],
        backgroundColor: ["#276088", "#F69326", "#34A853"],
        borderColor: ["#276088", "#F69326", "#34A853"],
        borderWidth: 1,
        borderRadius: "25px",
      },
    ],
  };
  // for Rainfall LineChart
  const RainfallDate = datahistoricalData?.map((item) => item.precipDateFormat);

  const RainFallAmount = datahistoricalData?.map(
    (item) => item.evenTrackPrecipAmt || 0,
  );

  const LineData = {
    labels: RainfallDate,
    datasets: [
      {
        label: "Rain Amt",
        data: RainFallAmount,
        backgroundColor: "white",
        borderColor: "aqua",
        pointBorderColor: "aqua",
        fill: false,
        tension: 0.1,
      },
    ],
  };

  const PieChart = {
    datasets: [
      {
        data: [
          itemListData?.result?.noOfViolation,
          itemListData?.result?.noOfReprimand,
          itemListData?.result?.noOfAction,
        ],
        backgroundColor: ["#f69326", "#d30d25", "#1b436e", "#276088"],
        borderColor: ["#f69326", "#d30d25", "#1b436e", "#276088"],
        borderWidth: 1,
        borderRadius: "25px",
      },
    ],
    labels: ["Corrective", "Reprimand", "Action"],
  };

  const SwItemValuePieChart = {
    datasets: [
      {
        data: [
          itemListData?.totalFourDaysOpen,
          itemListData?.totalSevenDaysOpen,
          itemListData?.totalMoreThanSevenDaysOpen,
        ],
        backgroundColor: ["#FFCC4D", "#FF3600", "#D30D25"],
        borderColor: ["#FFCC4D", "#FF3600", "#D30D25"],
        borderWidth: 1,
        borderRadius: "25px",
      },
    ],
    labels: ["Open 1-4 Days", "Open 4-7 Days", "Open > 7 Days"],
  };

  const PieChartReportData = {
    datasets: [
      {
        data: [
          lmsReportData?.Completed,
          lmsReportData?.InProgress,
          lmsReportData?.InCompleted,
        ],
        backgroundColor: ["#F69326", "#34A853", "#D30D25"],
        borderColor: ["#F69326", "#34A853", "#D30D25"],
        borderWidth: 1,
        borderRadius: "25px",
      },
    ],
    labels: ["Completed", "In Progress", "Incomplete"],
  };

  const options = {
    tooltips: {
      enabled: false,
    },
    responsive: true,

    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          useBorderRadius: true,
          pointStyleWidth: 11,
          boxHeight: 8,
          height: "5px",
          borderWidth: 1,
          padding: 20,
          font: {
            size: "12px",
            weight: "500",
          },
          color: mode === "dark" ? "#fff" : "#333333",
        },
      },
      datalabels: {
        formatter: (value, ctx) => {
          let sum = 0;
          let dataArr = ctx.chart.data.datasets[0].data;
          dataArr.forEach((data) => {
            sum += data;
          });
          let percentage = ((value * 100) / sum).toFixed(2);
          if (isNaN(percentage) || percentage === "0.00") {
            return "0";
          }
          return percentage + "%";
        },
        color: mode === "dark" ? "#fff" : "#333333",
        font: {
          size: 12,
          weight: 500,
        },
      },

      onHover: function (e) {
        e.native.target.style.cursor = "pointer";
      },
      rotation: 270,
      events: ["click"],
      onClick: function (event, element) {},
    },
  };

  const LineOptions = {
    ...options,

    scales: {
      x: {
        display: true,
        title: {
          display: true,
          text: "Date",
          color: "black",
          font: {
            size: 14,
          },
        },
      },
      y: {
        display: true,
        title: {
          display: true,
          text: "Rain Amount(Inches)",
          color: "black",
          font: {
            size: 14,
          },
        },
        min: 0,
      },
    },
    plugins: {
      ...options.plugins,
      legend: false,
    },
  };

  // Options for dashboard pie chart with percentages in legend
  const dashboardPieOptions = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 1,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          useBorderRadius: true,
          pointStyleWidth: 11,
          boxHeight: 8,
          height: "5px",
          borderWidth: 1,
          padding: 15,
          font: {
            size: 12,
            weight: "500",
          },
          color: mode === "dark" ? "#fff" : "#333333",
          generateLabels: (chart) => {
            const data = chart.data;
            if (data.labels.length && data.datasets.length) {
              const dataset = data.datasets[0];
              const total = dataset.data.reduce((acc, val) => acc + val, 0);

              return data.labels.map((label, i) => {
                const value = dataset.data[i];
                const percentage =
                  total > 0 ? ((value * 100) / total).toFixed(1) : 0;

                return {
                  text: `${label} (${percentage}%)`,
                  fillStyle: dataset.backgroundColor[i],
                  strokeStyle: dataset.borderColor[i],
                  lineWidth: dataset.borderWidth,
                  hidden: false,
                  index: i,
                  pointStyle: "circle",
                  fontColor: mode === "dark" ? "#ffffff" : "#333333",
                };
              });
            }
            return [];
          },
        },
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (context) {
            const label = context.label || "";
            const value = context.parsed || 0;
            const dataset = context.dataset;
            const total = dataset.data.reduce((acc, val) => acc + val, 0);
            const percentage =
              total > 0 ? ((value * 100) / total).toFixed(1) : 0;
            return `${label}: ${value} (${percentage}%)`;
          },
        },
      },
      datalabels: {
        display: false, // Hide labels on pie slices
      },
    },
  };
  return (
    <>
      {DonutChart && <Doughnut data={graphData} options={options} />}
      {PieChart1 && <Pie data={PieChart} options={options} />}
      {PieChartDashboard && (
        <Pie data={PieChart} options={dashboardPieOptions} />
      )}
      {PieChartReport && <Pie data={PieChartReportData} options={options} />}

      {SwItemPieChart && <Pie data={SwItemValuePieChart} options={options} />}
      {LineChart && <Line data={LineData} options={LineOptions} />}
    </>
  );
};

export default DonoughtChart;
